export default __webpack_public_path__ + "media/images/gallery/30-31f9f77b713aee53eb0b79704125f989.jpg";